const isNumber = (number) => typeof +number === 'number' && !Number.isNaN(+number) && Number.isFinite(+number)
export const isValidNumber = (number) => isNumber(number) && number != null && number !== ''
